import React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { InputTextarea } from 'primereact/inputtextarea';

interface AddNoteProps {
    addNote: boolean;
    hideNotesDialog: () => void;
    saveNoteHandler: () => void;
    noteText: string;
    setNoteText: (value: string) => void;
    noteLoading: boolean;
    title?: string;
}

const AddNote = ({
    addNote,
    hideNotesDialog,
    saveNoteHandler,
    noteText,
    setNoteText,
    noteLoading,
    title = 'Add Note'
}: AddNoteProps) => {
    return (
        <Dialog
            visible={addNote}
            style={{ width: '500px' }}
            header={title}
            className="mx-3 lg:mx-0"
            draggable={false}
            modal
            footer={
                <>
                    <Button
                        label="Cancel"
                        icon="pi pi-times"
                        className="p-button-secondary"
                        onClick={hideNotesDialog}
                    />
                    <Button
                        label="Save"
                        icon="pi pi-check"
                        className="common-primary-button"
                        onClick={saveNoteHandler}
                        loading={noteLoading}
                    />
                </>
            }
            onHide={hideNotesDialog}
        >
            <div className="grid p-fluid formgrid">
                <div className="field col-12">
                    <label htmlFor="noteText">Note</label>
                    <div className="input-effect-div">
                        <InputTextarea
                            id="noteText"
                            rows={3}
                            value={noteText}
                            onChange={(e) => setNoteText(e.target.value)}
                            placeholder="Enter note here..."
                        />
                        <span className="focus-bg"></span>
                    </div>
                </div>
            </div>
        </Dialog>
    );
};

export default AddNote;